export * from '@fhs/routing/src/routes/receipt/[rbiOrderId]';
export { default } from '@fhs/routing/src/routes/receipt/[rbiOrderId]';
